
<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h3><i class="fa-solid fa-users me-2"></i>Benutzer ({{totalEntries}})</h3>
</div>

<div class="d-flex align-items-center gap-3 mb-3">
    <button type="button" class="btn btn-primary" [routerLink]="['/user/detail', 0]">Benutzer anlegen</button>
    <div class="form-check mb-0">
        <input class="form-check-input" type="checkbox" id="showInactive" [(ngModel)]="showInactive" (change)="checkFilterAndList()">
        <label class="form-check-label" for="showInactive">Zeige inaktive Benutzer</label>
    </div>
</div>

<pagination
        [hidden]="entries?.length === 0"
        [totalItems]="totalEntries"
        [itemsPerPage]="paginConfig.itemsPerPage"
        [(ngModel)]="paginConfig.page"
        (pageChanged)="listEntries($event)"
        [maxSize]="20"
        previousText="Letzte"
        nextText="Nächste"
/>

<div class="table-responsive">
    <table *ngIf="entries?.length > 0" class="table table-sm table-striped table-hover bg-white pointer">
        <thead>
        <tr>
            <th style="width: 150px" (click)="setOrder('name')">
                Name <i class="fas" *ngIf="predicate === 'name'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th>Kürzel</th>
            <th>Rollen</th>
            <th (click)="setOrder('last_login')">
                Letzter Login <i class="fas" *ngIf="predicate === 'last_login'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('active')">
                Aktiv <i class="fas" *ngIf="predicate === 'active'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th>Rechte</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let entry of entries" [routerLink]="['/user/detail', entry.id]" [class.bg-danger-subtle]="!entry.active">
            <td>{{ entry.name }}</td>
            <td>{{ entry.short }}</td>
            <td>
                <ul class="list-inline roles mb-0">
                    <li class="list-inline-item me-0" *ngFor="let role of entry.roles">{{ role | teamRole }}</li>
                </ul>
            </td>
            <td>
                {{ entry.last_login | date: 'dd.MM.yyyy, HH:mm' }}
                <span class="text-muted" *ngIf="!entry.last_login">Noch nicht angemeldet</span>
            </td>
            <td>{{ entry.active | yesNo }}</td>
            <td>{{ entry.activeRights }}/{{ entry.rights }}</td>
        </tr>
        </tbody>
    </table>
</div>
